import store from '@state/store'
import { lazyLoadView } from '@router/helpers'
import usersRoutes from '@users/routes'
import authRoutes from '@auth/routes'
import companiesRoutes from '@companies/routes'
import eventsRoutes from '@events/routes'
import marketplaceRoutes from '@marketplace/routes'
import adminCompaniesRoutes from '@adminCompanies/routes'
import adminGroupsRoutes from '@adminGroups/routes'
import adminUsersRoutes from '@adminUsers/routes'
import adminWidgetsRoutes from '@adminWidgets/routes'
import kyndPoints from '@kynd-points/routes'
import interestsRoutes from '@interests/routes'
import challengeRoutes from '@challenges/routes'
import postsRoutes from '@posts/routes'
import reportsRoutes from '@reports/routes'

export default [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'login' },
  },
  ...usersRoutes,
  ...authRoutes,
  ...companiesRoutes,
  ...eventsRoutes,
  ...marketplaceRoutes,
  ...adminCompaniesRoutes,
  ...adminGroupsRoutes,
  ...adminUsersRoutes,
  ...adminWidgetsRoutes,
  ...kyndPoints,
  ...interestsRoutes,
  ...challengeRoutes,
  ...postsRoutes,
  ...reportsRoutes,
  {
    path: '/product-features',
    name: 'productFeatures',
    component: () =>
      lazyLoadView(
        import(
          /* webpackChunkName: "product-features" */
          './views/product-features.vue'
        )
      ),
    meta: {
      authRequired: true,
      tmp: {},
    },
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      lazyLoadView(import(/* webpackChunkName: "login" */ './views/_404.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          store
            .dispatch('auth/validate')
            .then(() => {
              next()
            })
            .catch(() => {
              next()
            })
        } else {
          next()
        }
      },
    },
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
